// extracted by mini-css-extract-plugin
export default {"component":"index-module__component--rGpKE","rotate":"index-module__rotate--zORhu"};